import store from '../store/store';

export default function getLanguageNameFromTag(locale: string): string {
    if (store.supportedLanguageMap.has(locale)) {
        return store.supportedLanguageMap.get(locale).LanguageName;
    }

    return null;
}
